import { AuthMode } from "../types";

export const showLiveStreamingPageUrl = (
  authMode: AuthMode | undefined
): boolean => {
  if (!authMode) {
    return false;
  }
  if (authMode === AuthMode.Private) {
    return false;
  }
  return true;
};
